<template>
	<div class="sidebar col-md-3" :class="{'sidebar-icon-only': (iconOnly && !collapsible) || (iconOnly && collapsible && isCollapsed), 'sidebar-collapsed': (!iconOnly && collapsible && isCollapsed)}">
		<div class="d-flex flex-column p-3" :class="{'d-none': (!iconOnly && collapsible && isCollapsed)}">
			<div class="d-flex align-items-center mb-0 me-md-auto link-dark text-decoration-none text-nowrap">
				<span class="fs-5" v-if="((collapsible && !isCollapsed) || (!iconOnly && !collapsible))">{{title}}</span>
				<span class="fs-5" v-else><span class="p-1"></span></span>
			</div>
			
			<hr class="divider-sidebar">
			
			<ul class="nav nav-pills flex-column mb-auto">
				<li class="nav-item nav-item-sidebar" v-for="module in modules" :key="module.name">
					<a v-if="module.target === '_blank'" :href="module.href" target="_blank" v-tooltip.right="{value: ((iconOnly && !collapsible) || (iconOnly && collapsible && isCollapsed) ? module.name : ''), class: ((iconOnly && !collapsible) || (iconOnly && collapsible && isCollapsed) ? 'p-tooltip-sidebar' : 'p-tooltip-none')}" class="nav-link link-dark d-flex align-items-center" :class="{'active p-button p-button-raised': module.isActive}" aria-current="page">
						<div class="row col-md-12 d-flex">
							<div class="col-md-2" :class="{'active': module.isActive}">
								<FontAwesomeIcon :icon="['fas', module.icon]" size="sm" width="18px" />
							</div>
							
							<div class="col-md-2 text-nowrap" v-if="((collapsible && !isCollapsed) || (!iconOnly && !collapsible))" :class="{'active': module.isActive}">{{module.name}}</div>
						</div>
					</a>
					<router-link v-else :to="module.href" v-tooltip.right="{value: ((iconOnly && !collapsible) || (iconOnly && collapsible && isCollapsed) ? module.name : ''), class: ((iconOnly && !collapsible) || (iconOnly && collapsible && isCollapsed) ? 'p-tooltip-sidebar' : 'p-tooltip-none')}" class="nav-link link-dark d-flex align-items-center" :class="{'active p-button p-button-raised': module.isActive}" aria-current="page" @click=resetCache>
						<div class="row col-md-12 d-flex">
							<div class="col-md-2" :class="{'active': module.isActive}">
								<FontAwesomeIcon :icon="['fas', module.icon]" size="sm" width="18px" />
							</div>
							
							<div class="col-md-2 text-nowrap" v-if="((collapsible && !isCollapsed) || (!iconOnly && !collapsible))" :class="{'active': module.isActive}">{{module.name}}</div>
						</div>
					</router-link>
				</li>
			</ul>
			
			<hr class="divider-sidebar">
		</div>
		
		<div class="collapsible-content" v-if="collapsible">
			<Button :icon="(isCollapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-left')" class="p-button-rounded p-button-secondary p-button-rounded-collapsible" @click="toggleCollapse" />
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
	import sidebarMixin from "@/mixin/sidebar";
	import portalMixin from "@/mixin/portal";
	import roleMixin from "@/mixin/role";
	
	export default defineComponent({
		mixins: [sidebarMixin, portalMixin, roleMixin],
		components: {
		},
		data() {
			return {
				isCollapsed: store.getters.isSidebarCollapsed
			}
		},
		computed: {
			modules() {
				var modules = [];
				
				if (this.isAdminPortal) {
					if (store.getters.isLoggedIn) {
						if (this.isAdmin) {
							modules.push({ name: "User", href: "/admin/user", icon: "user", isActive: (store.getters.getModule == "User" ? true : false) });
							modules.push({ name: "Company", href: "/admin/company", icon: "id-card", isActive: (store.getters.getModule == "Company" ? true : false) });
							modules.push({ name: "Conso Group", href: "/admin/consogroup", icon: "people-group", isActive: (store.getters.getModule == "ConsoGroup" ? true : false) });
							modules.push({ name: "Purpose", href: "/admin/purpose", icon: "file-edit", isActive: (store.getters.getModule == "Purpose" ? true : false) });
							modules.push({ name: "RPK Sheet", href: "/admin/sheet/rpk", icon: "book", isActive: (store.getters.getModule == "RPK Sheet" ? true : false) });
							modules.push({ name: "CWK Sheet", href: "/admin/sheet/cwk", icon: "book", isActive: (store.getters.getModule == "CWK Sheet" ? true : false) });
							modules.push({ name: "Sheet Editor", href: "/admin/sheet/editor", icon: "book", isActive: (store.getters.getModule == "Sheet Editor" ? true : false), target: "_blank" });
							modules.push({ name: "Account", href: "/admin/account", icon: "folder-open", isActive: (store.getters.getModule == "Account" ? true : false) });
							modules.push({ name: "Country", href: "/admin/country", icon: "globe", isActive: (store.getters.getModule == "Country" ? true : false) });
							modules.push({ name: "Currency", href: "/admin/currency", icon: "dollar", isActive: (store.getters.getModule == "Currency" ? true : false) });
							modules.push({ name: "Currency Exchange Rate", href: "/admin/currencyexchangerate", icon: "exchange", isActive: (store.getters.getModule == "CurrencyExchangeRate" ? true : false) });
							modules.push({ name: "Elimination Settings", href: "/admin/eliminationsetting", icon: "file", isActive: (store.getters.getModule == "EliminationSetting" ? true : false) });
						
							if (this.isRoot) {
								modules.push({ name: "Setting", href: "/admin/setting", icon: "cog", isActive: (store.getters.getModule == "Setting" ? true : false) });
							}
						}
						
						else if (this.isHQStaff) {
							modules.push({ name: "User", href: "/admin/user", icon: "user", isActive: (store.getters.getModule == "User" ? true : false) });
							modules.push({ name: "Conso Group", href: "/admin/consogroup", icon: "people-group", isActive: (store.getters.getModule == "ConsoGroup" ? true : false) });
							modules.push({ name: "Currency", href: "/admin/currency", icon: "dollar", isActive: (store.getters.getModule == "Currency" ? true : false) });
							modules.push({ name: "Currency Exchange Rate", href: "/admin/currencyexchangerate", icon: "exchange", isActive: (store.getters.getModule == "CurrencyExchangeRate" ? true : false) });
						}
					}
				}
				
				else if (this.isApprovalPortal) {
					//
				}
				
				// else if (this.isReportPortal) {
				// 	if (store.getters.isLoggedIn) {
				// 		modules.push({ name: "Report", href: "/reporting/report", icon: "chart-column", isActive: (store.getters.getModule == "Report" ? true : false) });
				// 	}
				// }
				
				else if (this.isAuditLogPortal) {
					//
				}
				
				else if (this.isEmployeePortal) {
					if (store.getters.isLoggedIn) {
						modules.push({ name: "Home", href: "/home", icon: "home", isActive: (store.getters.getModule == "Home" ? true : false) });
						modules.push({ name: "RPK", href: "/companyreport/rpk", icon: "calendar-plus", isActive: (store.getters.getModule == "RPK" ? true : false) });
						if (this.isAdmin || this.isHQStaff || this.isViewer) {
							modules.push({ name: "CWK", href: "/companyreport/cwk", icon: "briefcase", isActive: (store.getters.getModule == "CWK" ? true : false) });
							modules.push({ name: "Journal", href: "/journal", icon: "file-alt", isActive: (store.getters.getModule == "Journal" ? true : false) });
						}
						modules.push({ name: "Report", href: "/reporting/report", icon: "chart-column", isActive: (store.getters.getModule == "Report" ? true : false) });
					}
				}
				
				return modules;
			}
		},
		methods: {
			toggleCollapse() {
				this.isCollapsed = !this.isCollapsed;
				store.state.isSidebarCollapsed = this.isCollapsed;
				
				this.$emit('toggle-event');
			},
			resetCache() {
				store.state.cached = {page: null};
			}
		}
	});
</script>